import { TranslationService } from '@/utils/services/TranslationService';

import { CONTENT_ALBUMS } from '@/lib/routes/privateRoutes';

import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import AlbumsFeed from '@/components/pages/albums/Albums/AlbumsFeed';
import AlbumsPageHeaderRecap from '@/components/pages/albums/AlbumsPageHeaderRecap';
import AlbumsPageWrapper from '@/components/pages/albums/AlbumsPageWrapper';
import { PageContentWrapper } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper';

const Page = () => {
    return (
        <AlbumsPageWrapper>
            {({ toggleAlbumFunnel }) => (
                <>
                    <AlbumsPageHeaderRecap toggleAlbumFunnel={toggleAlbumFunnel} />
                    <PageContentWrapper>
                        <AlbumsFeed />
                    </PageContentWrapper>
                </>
            )}
        </AlbumsPageWrapper>
    );
};

const Albums = () => {
    return (
        <WrapperSwitchLayout>
            <Page />
        </WrapperSwitchLayout>
    );
};

export const getServerSideProps =
    TranslationService.getTranslationMessagesFromRoute(CONTENT_ALBUMS);

export default Albums;
